import { buildInteractiveColor } from './utils';
var colorVariables = {
  'colors/backgrounds/subtle-inline': buildInteractiveColor('#F0F1F1', '#F0F3F3', '#E2E4E4', '#F9F9F9'),
  'colors/borders/subtle-inline': buildInteractiveColor('#F0F1F1', '#F0F3F3', '#E2E4E4', '#F9F9F9')
};
export default colorVariables;
//# sourceMappingURL=colorsLightOverrides.js.map